"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dropdownMenu = _interopRequireDefault(require("../../dropdownMenu"));
const SelectOption = _ref => {
  let {
    id,
    className,
    value,
    children,
    onClick
  } = _ref;
  const onItemClick = event => {
    onClick?.(value, event);
  };
  return /*#__PURE__*/_react.default.createElement(_dropdownMenu.default.Item, {
    id: id,
    className: className,
    onClick: onItemClick
  }, children);
};
process.env.NODE_ENV !== "production" ? SelectOption.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  value: _propTypes.default.any,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func
} : void 0;
SelectOption.defaultProps = {
  id: undefined,
  className: undefined,
  value: undefined,
  children: undefined,
  onClick: undefined
};
var _default = exports.default = SelectOption;